import { render } from "./System.vue?vue&type=template&id=af6c95c4&scoped=true"
import script from "./System.vue?vue&type=script&lang=js"
export * from "./System.vue?vue&type=script&lang=js"

import "./System.vue?vue&type=style&index=0&id=af6c95c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af6c95c4"]])

export default __exports__